import { useCallback, useState } from 'react';

const useExpanded = () => {
  const [idx, setIdx] = useState<string>('');
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const onToggleExpanded = useCallback(
    (idx: string) => (): void => {
      setIdx(idx);
      setIsExpanded(prev => !prev);
    },
    [],
  );

  return {
    idx,
    isExpanded,
    onToggleExpanded,
  };
};

export default useExpanded;
